import EventsEmitter from 'events/EventsEmitter';

export default class StatsActions {
	static setStats = (value: any) => {
		EventsEmitter.emit('update_stats', value);
	};
}
